import React, { useEffect, useState } from 'react';
import { getConfigByKey } from '@api/endpoints/get/providers';
import styles from './index.module.scss';
import classNames from 'classnames';

export default function AppBanner({ className }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    getConfigByKey('banner').then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  const componentClasses = classNames(className, styles.AppBanner);
  const showBanner =
    !loading && data && !(opened && data.hideOnClick) && data.title;

  return (
    <>
      {showBanner ? (
        <div className={componentClasses}>
          {data.title}
          {data.linkTitle && data.linkSrc && (
            <a
              href={data.linkSrc}
              className={styles.AppBannerLink}
              target="_blank"
              onClick={() => setOpened(true)}
            >
              {data.linkTitle}
            </a>
          )}
        </div>
      ) : null}
    </>
  );
}
